import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const PosTerminalUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onSuccess = () => {
    form.resetFields();

    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    if (values.transactionProcessType === 0) {
      values.transactionProcessType = null;
    }
    RequestHandler.put(`/PosMemberWorkPlace/UpdatePosTerminal`, values)
      .then((response) => {
        setLoading(false);
        if (response.success) {
          onSuccess();
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="PosTerminalUpdate"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item name="posMemberWorkplaceId" hidden>
            <Input />
          </Form.Item>
          <Form.Item label="Terminal Adı" name="name">
            <Input disabled={true} />
          </Form.Item>
          <Form.Item label="Terminal No" name="number">
            <Input disabled={true} />
          </Form.Item>
          <Form.Item label="Pos Hesap Kodu" name="erpBankAccountCode">
            <Input />
          </Form.Item>

          <Form.Item label="Plasiyer Kodu" name="salesCode">
            <Input/>
          </Form.Item>

          <Row justify="space-between">
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default PosTerminalUpdateForm;
